import { FC } from 'react'
import styled from 'styled-components'

import { Info, TypeStyle } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { StyledTooltip } from '../../../../Modal/primitives/shared-form-styles'
import { LogoFormContainer } from '../LogoFormContainer'

export const LogoColorDisplay: FC = () => {
  const { logoDisplayPrices } = LogoFormContainer.useContainer()
  const {
    embroidery: {
      modal: {
        forms: { dtcLogoEmbroideryForm: fixtures, logoOption },
      },
    },
  } = useTranslation()

  return (
    <Container>
      <Label>
        {logoOption.logoColorLabel}:
        <StyledTooltip content={<>{fixtures.logoColorPriceTooltip}</>} placement='bottom-start'>
          <button type='button' aria-label={fixtures.ariaLabelLogoColorTooltip}>
            <Info height='12px' width='12px' fill='#282828' />
          </button>
        </StyledTooltip>
        <PriceLabel>{logoDisplayPrices.selected}</PriceLabel>
      </Label>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
`

const Label = styled.label`
  ${TypeStyle.css.headlineMicro}
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  text-transform: uppercase;
  font-weight: ${o => o.theme.typography.font.weight[700]};
  letter-spacing: 2px;
  line-height: 18px;
`

const PriceLabel = styled(TypeStyle.BodySmall)`
  font-weight: ${o => o.theme.typography.font.weight[700]};
  line-height: 20px;
`
